import { useSelector } from 'react-redux';
import { getAccountOverview, getGeneralInfo } from '@/store/account/actions';
import { useActivePlan } from '@/services/hooks/useActivePlan';

export const useAreNewPromptsDisabled = (): { areNewPromptsDisabled: boolean } => {
    const { IsExpired } = useSelector(getGeneralInfo);
    const { AIToolsTextCount } = useSelector(getAccountOverview);
    const { ActivePlanDetails } = useActivePlan();
    const remainingCount =
        ActivePlanDetails.Limits?.AiToolsTextLimit && ActivePlanDetails.Limits.AiToolsTextLimit - AIToolsTextCount >= 0
            ? ActivePlanDetails.Limits.AiToolsTextLimit - AIToolsTextCount
            : 0;
    return { areNewPromptsDisabled: IsExpired || !(remainingCount > 0) };
};
